import $$ from 'cmn-utils';

const baseUrl = "/api/pay/device-service-charge/";
export default {
    list: (params) => $$.get(baseUrl + 'list', params),
    createPrepay: (params) => $$.post(baseUrl + 'wxpay/create-prepay', params),
    superPay: (params) => $$.post(baseUrl + 'super-pay', params),
    exportExcel: (params) => $$.get(baseUrl + 'export-excel', params),
    delete: (params) => $$.post(baseUrl + 'delete', params),
}